import React, { useState, useEffect } from "react";
import "./TodaysTaskModal.css";
import { IoCloseOutline } from "react-icons/io5";
import { useLanguage } from "../../../../LanguageProvider";
import { TbStack2 } from "react-icons/tb";

export default function TodaysTaskModal({ tasks, onClose, openDetailModal }) {
    const { getTranslation, language } = useLanguage();
    const [dontShowAgain, setDontShowAgain] = useState(false);

    const getFormattedDate = () => {
        const date = new Date();
        return date.toISOString().split("T")[0]; // YYYY-MM-DD format
    };

    useEffect(() => {
        const storedDate = localStorage.getItem("dontShowDate");
        const today = getFormattedDate();

        if (storedDate === today) {
            const storedValue = localStorage.getItem("dontShowToday") === "true";
            setDontShowAgain(storedValue);
        } else {
            // Yeni bir günse checkbox'ı sıfırla
            localStorage.removeItem("dontShowToday");
            localStorage.setItem("dontShowDate", today);
            setDontShowAgain(false);
        }
    }, []);

    const handleCheckboxChange = (event) => {
        const isChecked = event.target.checked;
        setDontShowAgain(isChecked);
        localStorage.setItem("dontShowToday", isChecked);
    };

    const formatDate = () => {
        const date = new Date();
        return new Intl.DateTimeFormat(language, {
            weekday: "long",
            day: "numeric",
            month: "short",
            year: "numeric",
        }).format(date);
    };

    const openTaskDetail = (task) =>{
        openDetailModal(task)
        onClose()
    }

    return (
        <div className="today-tasks-modal-overlay">
            <div className="today-tasks-modal-container">
                <IoCloseOutline
                    className="today-tasks-modal-button close"
                    onClick={onClose}
                />

                <span className="today-tasks-modal-title">
                    {getTranslation("todayTasks")}
                </span>
                <span className="today-tasks-modal-date">{formatDate()}</span>

                <div className="today-tasks-modal-content">
                    <span className="today-tasks-modal-sub-title">
                        {getTranslation("tasks")}
                    </span>

                    {tasks && tasks.length > 0 && (
                        tasks.map((task, index) => (
                            <div key={index} onClick={()=>openTaskDetail(task)} className="today-tasks-task-box">
                                <TbStack2
                                    size={22}
                                    style={{ width: "25px", marginRight: "5px" }}
                                />
                                {task.taskTitle}
                            </div>
                        ))
                    )}
                </div>

                {/* Checkbox */}
                <div className="dont-show-today">
                    <input
                        type="checkbox"
                        id="dontShowCheckbox"
                        checked={dontShowAgain}
                        onChange={handleCheckboxChange}
                    />
                    <label htmlFor="dontShowCheckbox">
                        {getTranslation("doNotShowAgainToday")}
                    </label>
                </div>
            </div>
        </div>
    );
}
